
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Editable from '@/mixins/Editable';
import Notification from '@/mixins/Notification';
import StackedForm from '@/mixins/StackedForm';
import VWrapper from '@/components/shared/VWrapper.vue';
import { namespace } from 'vuex-class';
import EditHealthCheckLoader from '@/components/healthCheck/EditHealthCheckLoader.vue';
import HealthCheckForm from '@/components/healthCheck/HealthCheckForm.vue';
import { HealthCheck as HealthCheckModel } from '@/interfaces/models/HealthCheck';
import { Venue } from '@/interfaces/models/Venue';
import { scrollToFailedField } from '@/util/helper';

const healthCheck = namespace('healthCheck');
const app = namespace('app');

@Component({
  components: { VWrapper, HealthCheckForm, EditHealthCheckLoader },
})
export default class EditHealthCheck extends mixins(Editable, Notification, StackedForm) {
  @healthCheck.Action('store') public store!: any;
  @healthCheck.Action('show') public show!: any;
  @healthCheck.Action('update') public update!: any;
  @healthCheck.State('active') public active!: HealthCheckModel;
  @app.State('venues') public venues!: Venue[];

  public $refs!: {
    form: InstanceType<typeof HealthCheckForm> & { getData: () => any; validate: () => Promise<boolean | boolean[]> };
  };

  get healthCheck() {
    if (this.editing && this.active) {
      return this.active;
    }

    return null;
  }

  get title() {
    return this.editing ? 'healthCheck.edit' : 'healthCheck.create';
  }

  public save() {
    this.$refs.form.validate().then(async (res: boolean | boolean[]) => {
      this.$startLoading('healthCheck.saving');
      if (this.isValid(res)) {
        if (this.editing) {
          await this.update({ ...this.$refs.form.getData(), id: this.healthCheck!._id });
        } else {
          await this.store(this.$refs.form.getData());
        }

        this.$router.push({ name: 'healthCheck.index', query: { ...this.$route.query } });
      } else {
        scrollToFailedField();

        this.notifyError('notification.form');
      }
      this.$stopLoading('healthCheck.saving');
    });
  }

  public async mounted() {
    if (this.editing) {
      this.$startLoading('healthCheck');
      await this.show({ id: this.id });
    }

    if (this.editing && !this.active) {
      this.$router.push({ name: 'healthCheck.index', query: { ...this.$route.query } });
    }
    this.$stopLoading('healthCheck');
  }
}
